import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import MissionDelegate from "../mission/MissionDelegate";
import MissionCC from "../mission/MissionCC";
import { useSelector } from "react-redux";
import { USER_ROLES } from "constants";
import MissionManagerModal from "./MissionManagerModal";
import UserInformationCard from "../mission/UserInformationCard";
import Row from "components/common/Row";
import Column from "components/common/Column";
import { MissionContext } from "../contexts/MissionTasksContext";
import MissionContactPerson from "../mission/MissionContactPerson";
import MissionProxyDelegate from "../mission/MissionProxyDelegate";
import MissionExpertSets from "../mission/MissionExpertSets";
import { useSearchParams } from "react-router-dom";

const defaultProps = {
    isShow: false,
    initModal: () => { },
};

const MissionConfigurationModal = ({ isShow, isShow1, initModal1, userOptions, initModal }) => {
    const missionContext = useContext(MissionContext);
    const authData = useSelector(s => s.auth.data);
    const [refreshMissionCC, setRefreshMissionCC] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const handleRemoveMissionConfigurationFromParams = () => {
        setSearchParams({});
    }

    const canChangeMissionManager = () => {
        if (USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
            USER_ROLES.it_admin.includes(parseInt(authData?.role_id))
        ) {
            return true;
        }
        return false;
    }

    const canChangeMissionDelegate = () => {
        // if (
        //     USER_ROLES.business_admin.includes(authData?.role_id) ||
        //     missionContext.missionManager === parseInt(authData?.id)
        // ) {
        //     return true;
        // }
        return false;
    }

    const canChangeMissionProxyDelgate = () => {
        if (
            USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
            USER_ROLES.it_admin.includes(parseInt(authData?.role_id)) ||
            missionContext.missionManager === parseInt(parseInt(authData?.id)) ||
            missionContext.missionDelegate === parseInt(parseInt(authData?.id))
        ) {
            return true;
        }
        return false;
    }

    const canChangeMissionContactPerson = () => {
        if (
            USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
            USER_ROLES.it_admin.includes(parseInt(authData?.role_id)) ||
            missionContext.missionManager === parseInt(authData?.id) ||
            missionContext.missionDelegate === parseInt(authData?.id)
        ) {
            return true;
        }
        return false;
    }

    const canChangeMissionActors = () => {
        if (
            USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
            USER_ROLES.it_admin.includes(parseInt(authData?.role_id)) ||
            missionContext.missionManager === parseInt(authData?.id)
        ) {
            return true;
        }
        return false;
    }


  const handleMissionManagerSuccess = () => {
    setRefreshMissionCC((prev) => !prev);
  };

    return (
        <Modal show={parseInt(searchParams.get("mission_configuration")) === 1 || isShow} size="xl" animation={false}>
            <Modal.Header closeButton onClick={() => {
                setSearchParams({});
                initModal();
            }}>
                <Modal.Title><h1>Mission Configuration</h1></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="pb-2">
                    <Row>
                        {
                            !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                            <Column col={6}>
                                <UserInformationCard
                                    cardHeaderText="Mission Manager"
                                    cardColor={"bg-light-3"}
                                    name={missionContext.missionData?.relationMissionManager?.name}
                                    email={missionContext.missionData?.relationMissionManager?.email}
                                    role={missionContext.missionData?.relationMissionManager?.role_name}
                                    status={"Assigned"}
                                    change={initModal1}
                                    buttonText={missionContext.missionData?.relationMissionManager === null ? "Assign" : "Change"}
                                    showButton={canChangeMissionManager()}
                                    infoText={"Mission Manager is not assigned."}
                                />
                            </Column>
                        }

                        <Column col={6}>
                            <MissionDelegate canChangeMissionDelegate={canChangeMissionDelegate} />
                        </Column>
                        <Column className='my-2' col={6}>
                            <MissionContactPerson canChangeMissionContactPerson={canChangeMissionContactPerson} />
                        </Column>
                        <Column className='my-2' col={6}>
                            <MissionProxyDelegate canChangeMissionProxyDelgate={canChangeMissionProxyDelgate} />
                        </Column>
                    </Row>
                    {
                        !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                        <MissionCC missionID={missionContext?.missionData?.id} canChangeMissionActors={canChangeMissionActors} refresh={refreshMissionCC}/>

                    }
                    {
                        !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                        <MissionExpertSets canModify={canChangeMissionActors()} />

                    }

                </div>
                {
                    !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                    <MissionManagerModal
                        isShow={isShow1}
                        initModal={initModal1}
                        data={userOptions}
                        onSuccess={handleMissionManagerSuccess}
                    />

                }

            </Modal.Body>
        </Modal>
    );
};

export default MissionConfigurationModal;
